import { EmployeeRole } from '../company/employeeRole.data';

export interface ActivationContext {
  estateId: string;
  email: string;
  name: string;
  lastName: string;
}

export interface CreateUserContext {
  user: CreatedUser;
}

export interface CreatedUser extends ActivationContext {
  id: string;
  userId: string;
  companyId: string;
  isEstateAdmin: string;
  state: UserCreationState;
  role: EmployeeRole;
  creatorId: string;
  createdDate: number;
  errorMsg?: string;
}

export enum UserCreationState {
  CREATED = 'created',
  SAVED = 'saved',
  DELETED = 'deleted',
  ERRORED = 'errored'
}

export enum UserCreationComment {
  ALREADY_EXIST = 'already_exist',
  OTHER_SUB = 'other_sub',
  ASSIGN_ERROR = 'assign_error',
  DEFECT_ERROR = 'defect_error',
  INVALID = 'invalid'
}

export interface CreateServiceUser {
  id: string;
  name: string;
  lastName: string;
  phone: string;
  /** isCoordinator ? crm admin : service user, but LEGACY: it could be both!  */
  creatorId: string;
  createDate: number | null;
  estateIds: string[];
  subcontractorId: string;
  isCoordinator: boolean;
  status: UserCreationState;
  statusComment: UserCreationComment | null;
  sendDate: number;
}
